import { render, staticRenderFns } from "./AddProyek.vue?vue&type=template&id=bd9905fe&lang=pug&"
import script from "./AddProyek.vue?vue&type=script&lang=js&"
export * from "./AddProyek.vue?vue&type=script&lang=js&"
import style0 from "./AddProyek.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports